/* eslint-disable @typescript-eslint/naming-convention */
/**
 * This file is generated, to regenerate it, run npm run generate-feature-flags
 */
export const LDFlagDefaults = {
  'betelgeuse-amplitude-in-embedded': true,
  'betelgeuse-demo-supergraph-in-enterprise-trial': true,
  'billing-configure-stripe-standard-plan': true,
  'billing-current-developer-plan-readable-id':
    'sub-developer-monthly-v2025-06-01',
  'billing-override-plan-transition': false,
  'billing-transition-scale-plan': true,
  'federation-2-10-version': '2.10.4-1',
  'federation-2-11-version': '2.11.7',
  'federation-2-12-version': '2.12.4',
  'federation-2-13-version': '2.13.4',
  'federation-2-14-version': '2.14.3',
  'federation-2-15-version': '2.15.1',
  'federation-2-9-version': '2.9.5',
  'federation-next-version': '2.15.1',
  'gov-proposal-checks-descriptions-warn': true,
  'gov-rebase-before-publish': false,
  'growth-allow-plan-readable-id': false,
  'growth-default-studio-plan': 'graphos-free-v1',
  'growth-event-name-performance-add-on-requests':
    'performance_add_on_operations',
  'growth-event-name-requests': 'standard_operations',
  'growth-event-name-subscription-addons':
    'no-of-subscription-addons-per-million-false',
  'growth-event-name-subscription-messages': 'subscription_update_events',
  'growth-show-deploy-ui': false,
  'growth-show-pending-and-registered-member-page': false,
  'growth-show-user-profile-survey': true,
  'growth-sync-scale-usage-data-to-s3': false,
  'growth-sync-usage-data-scale': true,
  houston_schema_publisher_migration: true,
  'identity-show-api-key-last-used': true,
  'insights-coordinate-usage-partition-count-override': 0,
  'insights-error-categorization-ui': true,
  'insights-traces2bigtable-bigtable-batch-size': 1000,
  mercury_show_hide_unreachable_types_toggle: true,
  'nebula-proposals-ga': true,
  'nebula-proposals-linter': true,
  'nebula-proposals-revision-history': true,
  'nebula-reapproval-required-on-change': true,
  nebula_proposals_merge_upstream: true,
  offline_license: false,
  'operations-l1-commercial-router-entitlements': true,
  'ops-generic-rate-limiter-rate-per-minute': 10,
  ops_Uplink_UseProxiedAuroraRDSPercent: 100,
  'orion-max-schemapublisher-attempts': 50,
  'orion-show-composition-rules': true,
  orion_fed_alpha: true,
  'persisted-queries-operation-client-name-display': true,
  'pulsar-disable-stats-for-error-stats': false,
  'pulsar-disable-stats-for-field-executions': false,
  'pulsar-disable-stats-for-query-stats': false,
  'pulsar-log-kafka-partitions': false,
  'pulsar-max-coordinate-usage-partitions-per-report': 32,
  'pulsar-min-coordinate-usage-records-per-partition': 2500,
  'pulsar-partition-stats-by-graph': true,
  'pulsar-partition-stats-by-graph-spread': 4,
  'pulsar-send-coordinate-usage': 100,
  'pulsar-send-field-usage-to-coordinate-usage': 0,
  pulsar_displayListAnalyticsLargeSchemas: true,
  pulsar_fed2Onboarding: true,
  pulsar_restrictClientVersions: true,
  'registry-allow-slack-channels-for-proposals-notifications-frontend': true,
  'registry-proposal-comment-and-review-events-frontend': true,
  'registry-proposal-enriched-payload-docs-frontend': true,
  'registry-show-new-launches-ui': false,
  'studio-amplitude-tracking-enabled': true,
  'tnt-enable-variant-api-key-ui': false,
  'tnt-scim-enrollment-ui': false,
  'tnt-self-service-saml-rotation': true,
  'tooling-proposals-use-has-warnings': true,
};
